import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { ModalHeader } from 'reactstrap';
import IntlMessages from 'util/IntlMessages';
import TextField from '@material-ui/core/TextField';
import AddShoppingCartOutlinedIcon from '@material-ui/icons/AddShoppingCartOutlined';
import Button from '@material-ui/core/Button';
import Ägare from "./Input/Ägare";
import AutoComplete from "./Inputs/AutoComplete";
import OrderTyp from "./Input/OrderTyp";
import MinaChildKonto from "./Input/MinaChildKonto";
import MinaChildKontoUser from "./Input/MinaChildKontoUser";
import Leverantor from "./Input/Leverantor";
import KopplaMed from "./Input/KopplaMed";
import KopplaOrderAvtal from "./Input/KopplaOrderAvtal";
import CopyfromOffert from "./Input/CopyfromOffert";
import { Divider, FormGroup, FormControlLabel, Switch,Grid } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import { FlareSharp } from '@material-ui/icons';
import { isEmpty,isUndefined } from 'lodash';
import { 
    getKundAvtalProspekt,saveThisNewOrder,onSetZeroKundSearch,getAfidOrderSittings,
    getAvtalDocsById,getKundprislista,onCheckAvtalkanOrder
} from "actions";
import MuiAlert from '@material-ui/lab/Alert';
import Alert from '@material-ui/lab/Alert';
import { Snackbar } from '@material-ui/core'
import { Redirect, Link} from 'react-router-dom'
import KundAutoComplete from '../KundAutoComplete'
import useMediaQuery from '@material-ui/core/useMediaQuery';
import TaggarComponent from 'components/TaggarComponent';
import OrderVariant from './Input/OrderVariant'
import OrderBekraftelseMall from './Input/MallInput'
import PrislistaInput from './Input/PrislistaInput'
import KontaktInput from './Input/KontaktInput'
import ChoooseDocument from './Input/ChoooseDocument'
import LeverantorKundList from './Input/LeverantorKundList'

const withMediaQuery = (queries = []) => Component => props => {
    const mediaProps = {}
    queries.forEach(q => {
      mediaProps[q[0]] = useMediaQuery(q[1])
    })
    return <Component {...mediaProps} {...props} />
  }

function Alert1(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}
const currencies = [
    {
        value: 0,
        label: <IntlMessages id="appKontoModule.Create.new1"/>
    },
    {
        value: 1,
        label: <IntlMessages id="appKontoModule.Avtal.Connect"/>,
    },
];
const styles = (theme) => ({
    root: {
        padding: theme.spacing(2),
        margin: theme.spacing(4),
    },
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});
const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);
const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);


function mapStateToProps({auth,Avtal,accountsData,Order}) {
    const { authUser} = auth;
    const { Userlista,AvtalTyp,KundSearch,ChildList,ChildKontoUsers
        ,isIamChild,Flags,OrderSetting,MyOfficeType,
        AktivaKunder } = accountsData;
    const { ListOfAVPro,AvtalOffertl,currentAvtalDocs} = Avtal;
    const { OrderMessage } = Order;
    return {
        Userlista,AvtalTyp,authUser,ListOfAVPro,OrderMessage,KundSearch,AvtalOffertl,ChildList,ChildKontoUsers,isIamChild,Flags,OrderSetting,
        currentAvtalDocs,AktivaKunder,MyOfficeType
    };
}


function mapDispatchToProps(dispatch) {
    return {
        getKundAvtalProspekt: (Orgnr, Afid, userid) => dispatch(getKundAvtalProspekt(Orgnr, Afid, userid)),
        getKundprislista: (Orgnr, Afid, userid) => dispatch(getKundprislista(Orgnr, Afid, userid)),
        saveThisNewOrder: (Orgnr, Afid, userid,norder) => dispatch(saveThisNewOrder(Orgnr, Afid, userid,norder)),
        onSetZeroKundSearch: () => dispatch(onSetZeroKundSearch()),
        getAfidOrderSittings: (Afid) => dispatch(getAfidOrderSittings(Afid)),
        getAvtalDocsById: (Orgrn,Afid,userid,Avtal,NoMes) => dispatch(getAvtalDocsById(Orgrn,Afid,userid,Avtal,NoMes)),
        onCheckAvtalkanOrder:(Afid,userid,Avtal,CallbackFunc) => dispatch(onCheckAvtalkanOrder(Afid,userid,Avtal,CallbackFunc)),
        dispatch
    };
}

class PopUpSO extends Component {
    state={
        open:false,
        showMessage:false,
        message:"",
        error:false,
        errorMessage:<IntlMessages id="Incorrect.fields.error"/>,
        nOrder:{
          kontakt: 0,
          kontaktObj: {FName: '', LName: '', Email: '', Tele: '', PersonNr: '',firmatecknare:0},
          OrderVariant: 'standard',
          orderBekraftelseMallId: this.props.OrderSetting.defaultProduktOrderTempid,
          PrisListId: 0,
          Documentslist: [],
          taggar: [],
            Kund:{},
            Ansvarig:this.props.authUser.user_id,
            OrderType:0,
            IsConnectedWith:0,
            AvtalId:0,
            leverantor:"",
            OffertID:0,
            Fetchkalkyl:false,
            Fetchdokument:false,
            Fetchkunddata:false,
            OrderAfid:this.props.authUser.user_Afid,
            Orderuserid:this.props.authUser.user_id,
            leverantorKund:"",
        }
    }
    setTaggar = (taggar) => {
      this.setState({
        nOrder:{
            ...this.state.nOrder,
            taggar:taggar
        }
      })
    }
    componentDidMount=()=>{
        let Afid = this.props.authUser.user_Afid
        this.props.getAfidOrderSittings(Afid)
       
    }
    componentDidUpdate=()=>{
        if(this.props.open !== this.state.open){
            this.setState({
                open:this.props.open,
                nOrder:{
                    ...this.state.nOrder,
                    OrderVariant: parseInt(this.props.OrderSetting.defaultOrderverient)===0?'standard':'orderbekraftelse',
                    orderBekraftelseMallId: this.props.OrderSetting.defaultProduktOrderTempid,
                }
            })
        }
        if(!isEmpty(this.props.OrderMessage) 
        && this.props.OrderMessage !== this.state.message) {
            this.setState({
                message:this.props.OrderMessage,
                showMessage:true
            })
        } 
        if(this.props.KundSearch.Orgnr !== this.state.nOrder.Kund.Orgnr) {
            let nku = {
                AF_kundnamn:this.props.KundSearch.KundNamn,
                Orgnr:this.props.KundSearch.Orgnr,
                Adress:this.props.KundSearch.adress,
                Postnr:this.props.KundSearch.postnr,
                Ort:this.props.KundSearch.ort,
                Source:this.props.KundSearch.Source,
                Active:isUndefined(this.props.KundSearch.Active)?this.props.KundSearch.isAktiv:this.props.KundSearch.Active
            }
            console.log(this.props.KundSearch,"CurrentProjekt")
            this.setState({
                nOrder:{
                    ...this.state.nOrder,
                    Kund:nku,
                    PrisListId:parseInt(this.props.KundSearch.DefaultPricelistId) !== 0 && !isUndefined(this.props.KundSearch.DefaultPricelistId) 
                    ? this.props.KundSearch.DefaultPricelistId 
                    : 0
                }
            })
        }

    }
    handleRequestClose =()=>{
        this.setState({
            showMessage:false 
        })
    }
    handleClose = () => {
        this.props.onSetZeroKundSearch()
        this.setState({
            open:false,
            showMessage:false,
            message:"",
            error:false,
            errorMessage:<IntlMessages id="Incorrect.fields.error"/>,
            nOrder:{
              kontakt: 0,
              kontaktObj: {FName: '', LName: '', Email: '', Tele: '', PersonNr: '',firmatecknare:0},
              OrderVariant: 'standard',
              orderBekraftelseMallId: 0,
              PrisListId: 0,
              taggar: [],
              Documentslist: [],
                Kund:{},
                Ansvarig:this.props.authUser.user_id,
                OrderType:0,
                leverantor:"",
                IsConnectedWith:0,
                AvtalId:0,
                OffertID:0,
                Fetchkalkyl:false,
                Fetchdokument:false,
                Fetchkunddata:false,
                leverantorKund:""
            }
        })
        this.props.handleClose(false)
     };
    selectthisKund = () =>{
        if(!isEmpty(this.props.KundSearch)){
        console.log(this.props.KundSearch,"KundSearch")
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        const Orgnr = this.props.KundSearch.Orgnr;
        this.props.getKundAvtalProspekt(Orgnr,Afid,userid)
        this.props.getKundprislista(Orgnr,Afid,userid)
        let nku = {
            AF_kundnamn:this.props.KundSearch.KundNamn,
            Orgnr:this.props.KundSearch.Orgnr,
            Adress:this.props.KundSearch.adress,
            Postnr:this.props.KundSearch.postnr,
            Ort:this.props.KundSearch.ort,
            Source:this.props.KundSearch.Source,
            Active:this.props.KundSearch.Active
        }
        
        this.setState({
            nOrder:{
                ...this.state.nOrder,
                Kund:nku,
                kontakt: 0,
                kontaktObj: {FName: '', LName: '', Email: '', Tele: '', PersonNr: '',firmatecknare:0},
                PrisListId: parseInt(this.props.KundSearch.DefaultPricelistId) !== 0 && !isUndefined(this.props.KundSearch.DefaultPricelistId) 
                              ? this.props.KundSearch.DefaultPricelistId 
                              : 0
            }
        })
    }
    }
   
    handleChange = (e) =>{
        console.log(e.target.name,"handleChange")
         if(e.target.name ==="AvtalId"){
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            const Orgnr = this.state.nOrder.Kund.Orgnr;
            this.props.getAvtalDocsById(Orgnr,Afid,userid,e.target.value,1)
            this.props.onCheckAvtalkanOrder(Afid,userid,e.target.value,(results)=>{
                console.log(results,"resultssss")
                if(results.canOrder === 0){
                    this.setState({
                        ...this.state,
                        error:true,
                        errorMessage:results.message
                    })
                }else{
                    this.setState({
                        ...this.state,
                        nOrder:{
                            ...this.state.nOrder,
                            [e.target.name]:e.target.value,
                            Documentslist: [],
                            Fetchkalkyl:parseInt(this.props.OrderSetting.KalkylOrderPop) === 0?false:true,
                            Fetchdokument:parseInt(this.props.OrderSetting.dokumentOrderPop) === 0?false:true,
                            Fetchkunddata:parseInt(this.props.OrderSetting.kunddataOrderPop) === 0?false:true,
                            
                        },
                        error:false,
                        errorMessage:<IntlMessages id="Incorrect.fields.error"/>
                    })
                }
            })
           
        }
       else if(e.target.name ==="OrderAfid"){
        this.setState({
            ...this.state,
            nOrder:{
                ...this.state.nOrder,
                [e.target.name]:e.target.value,
                Orderuserid:0,
                Ansvarig:0,
            },
            error:false,
            errorMessage:<IntlMessages id="Incorrect.fields.error"/>
        })
       }
        else{
            console.log({
                nOrder:{
                    ...this.state.nOrder,
                    [e.target.name]:e.target.value,
                  }
            },12222)
            let newOrder ={
                ...this.state.nOrder,
                [e.target.name]:e.target.value,
              }
            this.setState({
                nOrder:newOrder
            }) 
        }
        
    }
    handleChange2 = (e) =>{
        console.log(this.state.nOrder,122221)
      console.log(e.target.name,122221)
      console.log(e.target.value,122221)
        this.setState({
            nOrder:{
                ...this.state.nOrder,
                [e.target.name]:e.target.value,
            }
        })
    }
    handleChangeKontakt = (kontakt) => {
        console.log(this.state.nOrder,122222)
      this.setState({
        nOrder: {
          ...this.state.nOrder,
          kontaktObj: kontakt
        }
      })
    }
    handleChange1=(e)=>{
        console.log(this.state.nOrder,122223)
        let hasAvtalWithSameType=isEmpty(this.props.ListOfAVPro)?0:
        isEmpty(this.props.ListOfAVPro.filter(item=>{return item.Type === e.target.value && item.Orgnr === this.state.nOrder.Kund.Orgnr}))?0:
        this.props.ListOfAVPro.filter(item=>{return item.Type === e.target.value && item.Orgnr === this.state.nOrder.Kund.Orgnr})[0].id

        //
        if(parseInt(hasAvtalWithSameType) !== 0){
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            const Orgnr = this.state.nOrder.Kund.Orgnr;
            this.props.getAvtalDocsById(Orgnr,Afid,userid,hasAvtalWithSameType,1)
        }
        //
        this.setState({
            nOrder:{
                ...this.state.nOrder,
                OrderType:e.target.value,
                IsConnectedWith:parseInt(hasAvtalWithSameType) === 0?0:1,
                AvtalId:hasAvtalWithSameType,
            }
        }) 
    }
   
    handleChangeUser=(userid)=>{
        console.log(this.state.nOrder,122224)
        this.setState({
            nOrder:{
                ...this.state.nOrder,
                Orderuserid:userid,
                Ansvarig:userid,
            }
        })
    }
    handleChangeConnectOTA = (e) =>{
      /*  if(parseInt(e.target.value) === 1){
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            const Orgnr = this.state.nOrder.Kund.Orgnr;
            this.props.getKundAvtalProspekt(Orgnr,Afid,userid)
        }*/
        console.log(this.state.nOrder,122225)
        console.log(e.target,122225)
        console.log(e)
       /**/ this.setState({
            nOrder:{
                ...this.state.nOrder,
                AvtalId:0,
                OffertID:0,
                Documentslist: [],
                Fetchkalkyl:false,
                Fetchdokument:false,
                Fetchkunddata:false,
                [e.target.name]:e.target.value
            }
        })
    }
    handleCheckSwitch =(e)=>{
        console.log(this.state.nOrder,122226)
        this.setState({
            nOrder:{
                ...this.state.nOrder,
                [e.target.name]:e.target.checked
            }
        })
    }
    checkIfDisabled=()=>{        
       if(
           isEmpty(this.state.nOrder.Kund) || 
           (this.state.nOrder.AvtalTyp === 0) ||
           (
            parseInt(this.state.nOrder.IsConnectedWith) === 1 
               &&
            parseInt(this.state.nOrder.AvtalId) === 0
           )
        ){
        this.setState({
            error:true
        })
           return true
       }else{
        this.setState({
            error:false
        })
           return false
       }
    }
    savethisNewOrder=()=>{
        let isDisabled = this.checkIfDisabled();
        if(isDisabled){
            console.log("error")
        }
        else{
        const nOrder = this.state.nOrder
        const userid = this.props.authUser.user_id;
        const Afid = this.props.authUser.user_Afid;
        const Orgnr = this.state.nOrder.Kund.Orgnr;
        console.log(nOrder,122227)
        this.props.saveThisNewOrder(Orgnr,Afid,userid,nOrder)
        this.handleClose()
        }
    }
    render() {
        console.log(this.state.nOrder,"this.state.nOrder")
        const {open,nOrder} = this.state;
        const { fullScreen } = this.props;
        return (<>
            <Dialog onClose={this.handleClose} aria-labelledby="customized-dialog-title"
            fullScreen={fullScreen}
            open={open} fullWidth={true}
            disableBackdropClick={true}
            disableEscapeKeyDown={true}
            maxWidth={"xs"}>
        <ModalHeader className="modal-box-header bg-primary text-white">
            <IntlMessages id="Order.Create" />
            <IconButton className="text-white"
                onClick={this.handleClose}>
                <CloseIcon />
            </IconButton>
        </ModalHeader>
        <DialogContent dividers>
            <div>
                <div className="text-center">
                    <AddShoppingCartOutlinedIcon fontSize="large" color="primary" />
                </div>
                <form>
                    {
                        parseInt(this.props.isIamChild) === 1
                        && parseInt(this.props.MyOfficeType) !==2
                        ?
                        <>
                        <div style={{ height: 'auto' }}>
                            <MinaChildKonto
                            OrderAfid={nOrder.OrderAfid}
                            onChangenOrderAfid={this.handleChange}
                            />
                        </div>
                        </>
                        :""
                    }
                    <div style={{ height: 'auto',paddingTop: '15px' }}>
                    <KundAutoComplete
                    // Kund={nOrder.Kund}
                    Value={isUndefined(nOrder.Kund.AF_kundnamn)?0:nOrder.Kund.AF_kundnamn}
                     selectthisKund={this.selectthisKund}
                        /> 
                    {/*        <AutoComplete 
                         Kund={nOrder.Kund}
                         selectthisKund={this.selectthisKund}
                        />   */}
                    </div>
                   
                    <div className="row" style={{ paddingTop: '15px' }}>
                        <div className="col-6">
                            {
                                parseInt(this.props.isIamChild) === 1
                                && parseInt(this.props.MyOfficeType) !==2
                                ?
                                <MinaChildKontoUser
                                Ansvarig={nOrder.Ansvarig}
                                OrderAfid={nOrder.OrderAfid}
                                onChangeOOuser={this.handleChangeUser}
                                onChangenOrderUser={this.handleChange}
                                />
                                :
                                <Ägare
                                Ansvarig={isEmpty(nOrder.Ansvarig)?this.props.authUser.user_id:nOrder.Ansvarig}
                                selectedthisOwner={this.handleChange}
                                Userlista={this.props.Userlista}
                                />
                            }
                        </div>
                      
                        <div className="col-6">
                            <OrderTyp 
                            AvtalTyp={nOrder.OrderType}
                            OrderKund={nOrder.Kund}
                            AvtalTyplist={this.props.AvtalTyp}
                            selectedthisAvtalTyp={this.handleChange1}
                            />
                            {
                               nOrder.OrderType !== 0?
                                <Leverantor
                                Options={isEmpty(this.props.AvtalTyp.filter(item =>{                
                                    return item.type === nOrder.OrderType
                                }))?[]:this.props.AvtalTyp.filter(item =>{                
                                    return item.type === nOrder.OrderType
                                })[0].Operator}
                                OrderType={nOrder.OrderType}
                                leverantor={nOrder.leverantor}
                                AvtalTyplist={this.props.AvtalTyp}
                                selectedthisAvtalLeverantor={this.handleChange}
                                />
                                :""
                                 /**/
                            }
                        </div>
                      </div>
                    {
                        
                        !isEmpty(this.state.nOrder.Kund)?
                        (this.state.nOrder.Kund.Active === 1)?
                        <>
                        <div style={{ height: '25px', paddingTop: '15px', alignItems:'center' }}>
                            <Divider />
                        </div>
                        <div className="row" style={{ height: '64px', paddingTop: '15px' }}>
                        <div className="col-6">
                            <KopplaOrderAvtal  
                            disabled={parseInt(this.props.isIamChild) ===1 && 
                                parseInt(nOrder.OrderAfid) !==parseInt(this.props.authUser.user_Afid) 
                            }
                            OrderType={nOrder.OrderType}
                            ListOfAVPro={this.props.ListOfAVPro}
                            IsConnectedWith={nOrder.IsConnectedWith}
                            currencies={currencies}
                            handleChange={this.handleChangeConnectOTA}
                            />
                        </div>
                        {(parseInt(this.state.nOrder.IsConnectedWith) === 1)?
                        <div className="col-6">
                            <KopplaMed 
                            OrderType={nOrder.OrderType}
                            AvtalId={nOrder.AvtalId}
                            ListOfAVPro={this.props.ListOfAVPro}
                            selectedthisAvtalId={this.handleChange}
                            />
                        </div>
                        :""
                        }
                    </div>
                    {(parseInt(this.state.nOrder.IsConnectedWith) === 1 &&
                     parseInt(this.state.nOrder.AvtalId) !== 0
                    )?
                    <>
                    <div className="d-flex row">
                    <h4 className="col-5" style={{ marginTop: '10px', marginRight:'1rem' }}><IntlMessages id="Calculation.fetch" /></h4>
                            <div className="col">
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="Fetchkalkyl"
                                                value={nOrder.Fetchkalkyl}
                                                checked={nOrder.Fetchkalkyl}
                                                onChange={this.handleCheckSwitch}
                                                color="primary"
                                            />
                                        }
                                    />
                                </FormGroup>
                            </div>
                    </div>
                    {
                      nOrder.Fetchkalkyl === true?
                      
                      isEmpty(this.props.ListOfAVPro.filter(n=> {return parseInt(n.id) === parseInt(this.state.nOrder.AvtalId)}))?"":
                        parseInt(this.props.ListOfAVPro.filter(n=> {return parseInt(n.id) === parseInt(this.state.nOrder.AvtalId)})[0].typeFlag) > 1 &&
                        parseInt(this.props.ListOfAVPro.filter(n=>  {return parseInt(n.id) === parseInt(this.state.nOrder.AvtalId)})[0].typeFlag) < 4?
                        !isEmpty(this.props.AvtalOffertl)?
                        <div className="d-flex row">
                            <div className="col-12">
                                <CopyfromOffert
                                AvtalId={nOrder.AvtalId}
                                IsConnectedWith={nOrder.OffertID}
                                currencies={this.props.AvtalOffertl}
                                handleChange={this.handleChange}
                                />
                            </div>
                        </div>
                      :""
                      :""
                      :""  
                    }
                    <div className="d-flex row">
                    <h4 className="col-5" style={{ marginTop: '10px', marginRight:'1rem' }}><IntlMessages id="Document.fetch" /></h4>
                            <div className="col">
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="Fetchdokument"
                                                value={nOrder.Fetchdokument}
                                                checked={nOrder.Fetchdokument}
                                                onChange={this.handleCheckSwitch}
                                                color="primary"
                                            />
                                        }
                                    />
                                </FormGroup>
                            </div>
                    </div>
                    {
                        nOrder.Fetchdokument === true?
                        <div className="d-flex row">
                            <div className="col-12">
                            <ChoooseDocument
                            Documentslist={nOrder.Documentslist}
                            currentAvtalDocs={this.props.currentAvtalDocs}
                            onChangeHandle={this.handleChange2}
                            />
                            </div>
                        </div>
                        :""
                    }
                    <div className="d-flex row">
                    <h4 className="col-5" style={{ marginTop: '10px', marginRight:'1rem' }}><IntlMessages id="Customer.data.fetch" /></h4>
                            <div className="col">
                                <FormGroup row>
                                    <FormControlLabel
                                        control={
                                            <Switch
                                                name="Fetchkunddata"
                                                value={nOrder.Fetchkunddata}
                                                checked={nOrder.Fetchkunddata}
                                                onChange={this.handleCheckSwitch}
                                                color="primary"
                                            />
                                        }
                                    />
                                </FormGroup>
                            </div>
                    </div>
                    </>:
                    ""}
                        </>
                        :""    
                        :""    
                    }
                    {
                        isEmpty(this.props.AktivaKunder.filter(item=>{return parseInt(item.isleverantor) === 1}))?"":
                        <div className='mt-3'>
                        <LeverantorKundList
                        leverantorKund={nOrder.leverantorKund}
                        onChangeA={this.handleChange}
                        />
                        </div>
                        
                    }
                    {
                       parseInt(this.props.Flags.PrislistaIkalkyl) === 1?
                       <div className='mt-3'>
                       <PrislistaInput
                         PrisListId={nOrder.PrisListId}
                         onChange={this.handleChange}
                       />
                     </div>
                       :""
                    }
                    {
                      parseInt(this.props.Flags.OrderPlus) === 1 &&
                      <div className='mt-3'>
                        <OrderVariant
                          OrderVariant={nOrder.OrderVariant}
                          OrderKund={nOrder.Kund}
                          selectedthisOrderVariant={this.handleChange}
                        />
                      </div>
                    }
                    
                    {
                      nOrder.OrderVariant === 'orderbekraftelse' &&
                      <>
                        <div className='mt-3'>
                          <OrderBekraftelseMall
                            orderBekraftelseMallId={nOrder.orderBekraftelseMallId}
                            onChange={this.handleChange}
                            errorMall={false}
                          />
                        </div>
                        {
                            parseInt(this.props.Flags.PrislistaIkalkyl) === 0?
                            <div className='mt-3'>
                            <PrislistaInput
                              PrisListId={nOrder.PrisListId}
                              onChange={this.handleChange}
                            />
                          </div>
                            :""
                        }
                         </>
                    }
                        <div className='mt-3'>
                          <KontaktInput
                            kontakt={nOrder.kontakt}
                            kontaktObj={nOrder.kontaktObj}
                            handleChangeKontakt={this.handleChangeKontakt}
                            handleChange={this.handleChange}
                            OrderKund={nOrder.Kund}
                          />
                        </div> 
                     
                    <div className='mt-3'>
                      <TaggarComponent
                        Source={6}
                        onChange={this.setTaggar}
                      />
                    </div>
                    
                </form>
            </div>
            {
    this.state.error? 
    <Alert severity="warning">{this.state.errorMessage}</Alert>
    :""
}
            
        </DialogContent>
        <DialogActions>
            <Grid
                container
                direction="row"
                justify="space-between"
                alignItems="center"
                >
                <div>
                    <Button onClick={this.handleClose} variant="outlined" color="default" 
                    className="jr-btn">
                        <IntlMessages id="Cancel"/>
                    </Button>
                </div>
                <div className="ml-auto">
                    <Button
                    color="primary"
                    className="jr-btn"
                    variant="contained"
                    onClick={this.savethisNewOrder}
                    disabled={parseInt(nOrder.OrderType)===0}
                    >
                    <IntlMessages id="Create"/>
                    </Button>

{/*
                <Link 
     className={"MuiButtonBase-root MuiButton-root MuiButton-contained jr-btn MuiButton-containedPrimary"}
      
                    to={{
                        pathname: "/app/Orderkort",
                        state: { fromDashboard: true }
                      }}
                     variant="contained">
                        
                    </Link>
*/}
                </div>
            </Grid>
        </DialogActions>
    </Dialog>
    {/* <Snackbar
    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    open={this.state.showMessage}
    autoHideDuration={3000}
    onClose={this.handleRequestClose}
    ContentProps={{
        "aria-describedby": "message-id"
    }}>
        <Alert1 onClose={this.handleRequestClose} 
        severity={this.state.message === "Error"?"error":"success"}
        ><span id="message-id">{this.state.message}</span></Alert1>
    </Snackbar>  */}
    </>
        );
    }
}

export default connect(
    mapStateToProps,mapDispatchToProps
)((withMediaQuery([
    ['fullScreen', theme => theme.breakpoints.down('xs'), {
      defaultMatches: true
    }]
  ]))(PopUpSO));



